import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { initRolePermissions } from 'utils/constants';
import { RolePermissionType } from 'utils/permissions-type';

const ACCESS_ALL_ROUTES = {
  canAccessOverview: true,
  canAccessMeals: true,
  canAccessBaseItems: true,
  canAccessFeeds: true,
  canAccessRewards: true,
  canAccessGiftCards: true,
  canAccessMetadata: true,
  canAccessSettings: true,
  canAccessKitchenDetails: true,
  canAccessPolygons: true,
  canAccessTrash: true,
  canAccessCareers: true,
  canAccessBlog: true
};
export const permissionControls: Partial<Record<ENUM_ROLE, RolePermissionType>> = {
  [ENUM_ROLE.ADMIN]: {
    ...initRolePermissions,
    isAdminRole: true,
    canSearch: true,
    canAccessCreateList: true,
    canViewBlog: true,
    canViewCareers: true,
    canViewProfileDropDown: true,
    ...ACCESS_ALL_ROUTES
  },

  [ENUM_ROLE.SUPER_ADMIN]: {
    ...initRolePermissions,
    isSuperAdminRole: true,
    canSearch: true,
    canAccessCreateList: true,
    canViewBlog: true,
    canViewCareers: true,
    canViewProfileDropDown: true,
    ...ACCESS_ALL_ROUTES
  },

  [ENUM_ROLE.DEVELOPER]: {
    ...initRolePermissions,
    isDeveloperRole: true,
    canSearch: true,
    canAccessCreateList: true,
    canViewBlog: true,
    canViewCareers: true,
    canViewProfileDropDown: true,
    ...ACCESS_ALL_ROUTES
  },
  [ENUM_ROLE.HR_ADMIN]: {
    ...initRolePermissions,
    isHRRole: true,
    canViewCareers: true,
    canAccessCareers: true
  },
  [ENUM_ROLE.MARKETING_OPS_MANAGER]: {
    ...initRolePermissions,
    isMarketingRole: true,
    canViewBlog: true,
    canAccessBlog: true
  }
};
